<template>
  <div>
    <div class="dialogContainer">
      <el-form
        ref="handleForm"
        :model="handleForm"
        :rules="handleRules"
        label-position="right"
        label-width="90px"
      >
        <el-form-item label="广告位" prop="photoPath">
          <span>{{ handleForm.locationName }}</span>
        </el-form-item>
        <el-form-item label="图片" prop="photoPath">
          <div class="handle-form-input">
            <span>尺寸{{ vueCropperImgProps.width * vueCropperImgProps.enlarge }}x{{ vueCropperImgProps.heigth * vueCropperImgProps.enlarge }}</span>
            <el-button size="small" type="primary" class="fr" @click="cropperImgFn">
              点击上传
            </el-button>
          </div>
          <div class="picture-wrapper">
            <img v-if="handleForm.photoPath" :src="handleForm.photoPath" alt class="WHshow">
          </div>
        </el-form-item>
        <el-form-item label="投放" prop="stages">
          <el-checkbox-group v-model="checkList" @change="handlechange">
            <el-checkbox v-show="handleForm.locationId==='16'||handleForm.locationId==='17'" :label="`0`">
              学前
            </el-checkbox>
            <el-checkbox :label="`1`" :disabled="handleForm.locationId==='13' || handleForm.locationId==='15'">
              小学
            </el-checkbox>
            <el-checkbox :label="`2`" :disabled="handleForm.locationId==='12' || handleForm.locationId==='14'">
              中学
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="链接" prop="linkType">
          <el-radio-group v-model="handleForm.linkType" @change="radioChange">
            <el-radio :label="1">
              H5链接
            </el-radio>
            <el-radio :label="2">
              应用
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-show="handleForm.linkType===1" ref="linkPath" label="链接地址" prop="linkPath">
          <!-- v17.1 -->
          <el-input
            v-model="handleForm.linkPath"
            name="title"
            placeholder="url"
            class="handle-form-input"
            @input="linkPathChange"
          />
        </el-form-item>
        <el-form-item v-show="handleForm.linkType===2" ref="applyId" label="应用编号" prop="applyId">
          <el-input
            v-model="handleForm.applyId"
            name="title"
            placeholder="应用编号"
            class="handle-form-input"
          />
        </el-form-item>
        <!-- v17.1 -->
        <el-form-item v-show="showType && handleForm.linkType===1" label=" ">
          <el-select
            v-model="handleForm.showType"
            name="showType"
            size="medium"
          >
            <el-option
              label="保留原生框架"
              value="0"
            />
            <el-option
              label="全屏展示"
              value="1"
            />
          </el-select>
        </el-form-item>
        <div class="dsc">
          <p>尺寸：{{ vueCropperImgProps.width * vueCropperImgProps.enlarge }}x{{ vueCropperImgProps.heigth * vueCropperImgProps.enlarge }}</p>
          <p>大小：4M内</p>
          <p>格式：JPG,PNG</p>
          <p>说明：后台若无发布广告，前端留空(无租赁广告展示) 页面链接，课桌先生进入后无框架</p>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="closeDialog">
        取消
      </el-button>
      <el-button
        :loading="ajaxLoading"
        type="primary"
        size="medium"
        @click="handleAddSubject"
      >
        {{ ajaxLoading?'Loading':'保存' }}
      </el-button>
    </div>
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="hiddenVariable.title"
      append-to-body
      width="620px"
    >
      <vue-cropper-img
        :props-w-h="vueCropperImgProps"
        :size="4"
        @closeDialog="closeDialogFn"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// 获取API
import { getAdvertisingsAdd, getAdvertisingsEdit } from '@/api/productOperation/mrDesk/prosepoems';
import { getApptypesTree } from '@/api/productOperation/common/applicationTypeManage';

export default {
  name: 'DialogInfo',
  props: {
    type: {
      type: String,
      default: null
    },
    propsImgwh: {
      type: String,
      default: null
    },
    dataList: {
      type: Object,
      default: null
    }
  },
  data() {
    const validateImage = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请上传广告图片'));
      } else {
        callback();
      }
    };
    const validatelinkPath = (rule, value, callback) => {
      if (this.handleForm.linkType === 1 && !value) {
        callback(new Error('链接地址不能为空'));
      } else {
        callback();
      }
    };
    const validateapplyId = (rule, value, callback) => {
      if (this.handleForm.linkType === 2 && !value) {
        callback(new Error('应用编号不能为空'));
      } else {
        callback();
      }
    };
    return {
      checkList: [],
      hiddenVariable: {
        dialogEditVisible: false,
        title: ''
      },
      vueCropperImgProps: {
        width: 560,
        heigth: 130,
        enlarge: 1
      },
      ajaxLoading: false,
      CascaderOptions: [],
      // 操作表单
      uploadFile: null,
      handleForm: {
        type: '',
        id: '',
        linkType: 1
      },
      // v17.1
      showType: false,
      apptypesTree: [],
      apptypesProps: {
        children: 'children',
        value: 'id',
        label: 'name',
        multiple: true,
        emitPath: false
      },
      imgW: '',
      imgH: '',
      handleRules: {
        photoPath: [
          { required: true, trigger: 'blur', validator: validateImage }
        ],
        stages: [
          { required: true, message: '投放对象不能为空', trigger: 'blur' }
        ],
        linkType: [
          { required: true, message: '链接不能为空', trigger: 'blur' }
        ],
        linkPath: [
          { required: true, trigger: 'blur', validator: validatelinkPath }
        ],
        applyId: [
          { required: true, trigger: 'blur', validator: validateapplyId }
        ]

      }
    };
  },
  computed: {
    // 获取上传图片地址
    ...mapGetters(['deskadvertisingsUrl'])
  },
  watch: {
    dataList: {
      handler(val) {
        if (val) {
          this.handleForm = val;
          this.checkList = val.stages.split(',');
        } else {
          this.handleForm = { linkType: 1, stages: '' };
          // v17.1
          this.handleForm = { linkType: 1, stages: '' };
          this.checkList = [];
        }
        // v17.1
        this.linkPathChange();
      }
    },
    type: {
      handler(val) {
        // this.fetchApptypesTree();
        if (val === 'edit' && this.dataList.length > 0) {
          this.handleForm = this.dataList;
          this.checkList = this.dataList.stages.split(',');
        } else {
          this.handleForm = { linkType: 1, stages: '' };
          // v17.1
          this.handleForm = { linkType: 1, stages: '', linkPath: '', showType: '0' };
          this.checkList = [];
        }
        // v17.1
        this.linkPathChange();
      }
    }

  },
  mounted() {
    var wh = this.propsImgwh.split(',');
    this.vueCropperImgProps.width = wh[0];
    this.vueCropperImgProps.heigth = wh[1];
    this.imgW = wh[0];
    this.imgH = wh[1];
    if (wh[0] > 500 || wh[1] > 400) {
      this.vueCropperImgProps.enlarge = 2;
      this.vueCropperImgProps.width = wh[0] / 2;
      this.vueCropperImgProps.heigth = wh[1] / 2;
    }
    if (this.dataList.id) {
      this.handleForm = this.dataList;
      this.checkList = this.dataList.stages.split(',');
    } else {
      // this.handleForm = { linkType: 1, stages: '1', ...this.dataList };
      // v17.1
      this.handleForm = { linkType: 1, stages: '', ...this.dataList, showType: '0' };
      this.checkList = [];
    }
    this.linkPathChange();
  },
  methods: {
    // 获取应用类型列表
    fetchApptypesTree() {
      getApptypesTree(this.searchForm)
        .then(result => {
          this.apptypesTree = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 新增
    handleAddSubject() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          this.ajaxLoading = true;
          const stages = this.checkList.length > 0 ? this.checkList.join(',') : this.checkList.join('');
          const option = {
            applyId: this.handleForm.linkType === 2 ? this.handleForm.applyId : '',
            format: this.handleForm.format,
            high: this.imgH,
            wide: this.imgW,
            linkType: this.handleForm.linkType,
            linkPath: this.handleForm.linkType === 1 ? this.handleForm.linkPath : '',
            photoPath: this.handleForm.photoPath,
            remark: this.handleForm.remark,
            size: this.handleForm.size,
            stages: stages,
            // v17.1
            showType: this.showType && this.handleForm.linkType === 1 ? parseInt(this.handleForm.showType) : 0,
            locationId: this.handleForm.locationId
          };
          if (this.type === 'add') { // 添加
            getAdvertisingsAdd(option)
              .then(res => {
                this.$emit('closeDialog');
                this.ajaxLoading = false;
              }).catch(err => {
                this.ajaxLoading = false;
                console.log(err);
              });
          } else if (this.type === 'edit') { // 编辑
            getAdvertisingsEdit(option, this.handleForm.id)
              .then(res => {
                this.$emit('closeDialog');
                this.ajaxLoading = false;
              }).catch(err => {
                this.ajaxLoading = false;
                console.log(err);
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    linkPathChange() {
      if (this.handleForm.linkPath && (this.handleForm.linkPath.indexOf('http://') === 0 || this.handleForm.linkPath.indexOf('https://') === 0)) {
        this.showType = true;
      } else {
        this.showType = false;
      }
    },
    // 图片上传成功
    cropperImgFn() {
      this.hiddenVariable.dialogEditVisible = true;
      this.hiddenVariable.title = '课桌广告图片上传';
    },
    handlechange(val) {
      this.handleForm.stages = val.length > 0 ? val.join(',') : val.join('');
    },
    closeDialogFn(val) {
      this.hiddenVariable.dialogEditVisible = false;
      this.$set(this.handleForm, 'photoPath', val.absolutePath);
      this.handleForm.size = val.imgsize;
      this.handleForm.format = val.suffix;
      this.$refs.handleForm.validateField('photoPath');
      this.$forceUpdate();
    },
    radioChange() {
      if (this.handleForm.linkType === 2) {
        this.$refs['linkPath'].clearValidate();
      } else if (this.handleForm.linkType === 1) {
        this.$refs['applyId'].clearValidate();
      }
    },

    // 关闭
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
};
</script>
<style lang="scss" scoped>

.upload-picture {
  float: right;
}
.handle-form-input {
  width: 96%;
}
.picture-wrapper {
  width: 96%;
  height: 100px;
  margin-top: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
.dialog-footer {
  text-align: right;
  padding-top: 20px;
}
.dsc {
  color: #666;
  line-height: 20px;
  background: #fff1e5;
  border-radius: 10px;
  border: 1px solid #ffd3ae;
  padding: 10px 20px;
  margin: 10px 0;
  font-size: 12px;
}
.fr{
  float: right;
}
.WHshow{
  max-width: 100%;
  max-height: 100%;
}
</style>
